import React from 'react';
import { TopToolbar } from 'react-admin';
import UpdateRoles from './UpdateRoles';
import AddToWatchList from './AddToWatchList';
import UpdateVerificationLevel from './UpdateVerificationLevel';

const UserEditActions = ({ basePath, data, resource }) => (
	<TopToolbar>
		{data && (
			<React.Fragment>
				<UpdateRoles record={data} />
				<UpdateVerificationLevel record={data} />
				<AddToWatchList record={data} />

			</React.Fragment>
		)}
	</TopToolbar>
);

export default UserEditActions;
